import React, { useState } from 'react';
import BottomTabBar from '../components/util/BottomTabBar';
import Header from '../components/util/Header';
import GlobalSearchModal from '../modal/GlobalSearchModal';
import './StorePage.css';

const Event = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="container">
    <Header useLogo={true} left="" title="" rightIcon1="" rightIcon2=""/>
    <img src="/event_full.png" style={{width: '100%'}} alt="pointshop" />
    <BottomTabBar/>
    {isModalOpen && (
    <>
    <div className="modal-wrapper">
        <GlobalSearchModal onClose={()=>setIsModalOpen(false)}/>
    </div>
    </>
  )
};
  </div>
  )
}
  

export default Event;
